var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Menu"),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"48","d":"M88 152h336M88 256h336M88 360h336","key":1})]);
}

Menu.defaultProps = {"className":"ionicon","viewBox":"0 0 512 512"};

module.exports = Menu;

Menu.default = Menu;
